import { NavigationBrands } from "@components/widgets/AppSubNav";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { PageClients } from "@src/components/modules/clients/listing/PageClients";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Clients`} navigation={<NavigationBrands />}>
    <DemoModule module={Modules.Clients}>
      <PageClients />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/clients/")({
  component: Page,
});
